var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 75,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 25,
    width: 25,
    height: 25,
    fill: "#366420"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    width: 25,
    height: 25,
    fill: "#006E40"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 50,
    width: 25,
    height: 25,
    fill: "#82E392"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 25,
    height: 25,
    fill: "#008756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.72e5cf455ea557161f4005e77a54b22d.svg";
export { ForwardRef as ReactComponent };